import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicalCross: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="medical-cross, first-aid, emergency"><path fillRule="evenodd" clipRule="evenodd" d="M8.75 2.75L8.75 8.75H2.75L2.75 15.25L8.75 15.25L8.75 21.25L15.25 21.25L15.25 15.25L21.25 15.25L21.25 8.75L15.25 8.75L15.25 2.75L8.75 2.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMedicalCross;
